import Header1 from 'components/typography/header-1';
import Header2 from 'components/typography/header-2';
import Action from 'components/typography/action';
import P1 from 'components/typography/p-1';
import P2 from 'components/typography/p-2';
import P3 from 'components/typography/p-3';
import { TextAlign, TextColor, TextWeight, TextTag } from 'components/typography/text';

export { Header1, Header2, Action, P1, P2, P3, TextAlign, TextColor, TextWeight, TextTag };
